import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜问答
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于52吃瓜网的常见问题解答
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="text-sm font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0">Q:</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}